<template>
	<div class="grid-x grid-margin-x align-center course-desc">
		<div class="small-12 medium-10 large-8">
			<h2>{{this.dctxt('information_about_course')}}</h2>

			<p
				ref="courseDesc"
				v-bind:class="{
					'course-desc-accordion': hasAccordion,
					expanded: accordionExpanded,
				}"
				>{{ text }}</p
			>

			<a
				href="#"
				v-if="hasAccordion"
				v-on:click.stop.prevent="toggleAccordion"
				:class="[
					'dc-button',
					'dc-button--has-icon',
					'dc-button--color-orange',
					'dc-toggle__button',
					{
						'dc-toggle__button--active': accordionExpanded,
					},
				]"
				role="button"
				rel="nofollow"
				aria-label="Expand accordion"
				:aria-expanded="accordionExpanded"
			>
				<span class="icon icon-arrow-down"></span>
			</a>
		</div>
	</div>
</template>

<script>
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [
		Translatable
	],
	data() {
		return {
			hasAccordion: false,
			accordionExpanded: false,
			accordionHeight: null,
			accordionTreshhold: 240,
		};
	},
	props: {
		text: {
			type: String,
			required: true,
		},
	},
	methods: {
		calcCourseDescHeight() {
			//Reset
			this.$refs.courseDesc.style.height = null;
			this.hasAccordion = false;

			this.accordionHeight = this.$refs.courseDesc.clientHeight;
			if (this.accordionHeight > this.accordionTreshhold) {
				this.$refs.courseDesc.style.height = `${this.accordionTreshhold / 2}px`;
				this.hasAccordion = true;
			}
		},
		toggleAccordion() {
			this.accordionExpanded = !this.accordionExpanded;
			if (this.accordionExpanded) {
				this.$refs.courseDesc.style.height = `${this.accordionHeight}px`;
			} else {
				this.$refs.courseDesc.style.height = `${this.accordionTreshhold / 2}px`;
			}
		},
	},
	mounted() {
		this.calcCourseDescHeight();
		window.addEventListener('resize', this.calcCourseDescHeight);
	},
	destroyed() {
		window.removeEventListener('resize', this.calcCourseDescHeight);
	},
};
</script>
